__turbopack_context__.v({
  "className": "playfair_display_fd4df7bd-module__GIiuFq__className",
  "variable": "playfair_display_fd4df7bd-module__GIiuFq__variable",
});
